import PropTypes from "prop-types"
import { useQuery } from "react-query"
import { listCategories, listTags } from "~/actions/courses"
import CourseLessonContentContainer from "~/components/Common/CourseLessonContentContainer"
import CourseContent from "~/components/courses/CourseContent"
import CourseDetails from "~/components/courses/CourseDetails"
import Page from "~/pages/Page"
import Router from "~/router"

const Content = ({ routes = [], ...rest }) => {
  const { data: tags } = useQuery("tags", () => listTags())
  const { data: categories } = useQuery("categories", () => listCategories())

  return (
    <Page>
      <CourseLessonContentContainer
        leftComponent={<CourseDetails tags={tags} categories={categories} />}
        rightComponent={<CourseContent />}
      />
      <Router routes={routes} {...rest} />
    </Page>
  )
}

Content.propTypes = {
  routes: PropTypes.array,
}

export default Content
